export function parsePositionNumber(positionNumber?: string) {
  const parsedNumber = Number.parseInt(positionNumber ?? "", 10);
  return Number.isFinite(parsedNumber) ? parsedNumber : Number.MAX_SAFE_INTEGER;
}

export function assignConfigSubPositionIds<TProduct extends { positionId?: string }>(products: TProduct[]) {
  const basePositionId = products[0]?.positionId;
  if (!basePositionId) {
    return products;
  }

  return products.map((product, index) => {
    product.positionId = index === 0 ? basePositionId : `${basePositionId}.${buildAlphabeticSuffix(index)}`;
    return product;
  });
}

/**
 * Gives the provided products alphabetic sub-position ids.
 *
 * Example:
 * 1 -> 1.a, 1.b, ..., 1.z, 1.aa, 1.ab
 */
function buildAlphabeticSuffix(index: number) {
  let suffix = "";
  let remaining = index;

  while (remaining > 0) {
    remaining -= 1;
    suffix = String.fromCharCode(97 + (remaining % 26)) + suffix;
    remaining = Math.floor(remaining / 26);
  }

  return suffix;
}

export function comparePositionThenName(
  firstPosition?: string,
  firstName?: string,
  secondPosition?: string,
  secondName?: string,
) {
  const positionDelta = parsePositionNumber(firstPosition) - parsePositionNumber(secondPosition);
  if (positionDelta !== 0) {
    return positionDelta;
  }

  return (firstName ?? "").localeCompare(secondName ?? "");
}

export function getLatestTopLevelPositionId(positionIds: Array<string | undefined>) {
  const validPositions = positionIds
    .map((positionId) => positionId?.split(".")[0])
    .map((part) => parseInt(part || "", 10))
    .filter((value) => !isNaN(value));

  return validPositions.length > 0 ? Math.max(...validPositions) : 0;
}
